import React from 'react';

const Quote = () => (
  <p className="quote">
    Mathematics is about numbers, equations,computations, or algorithms: its is
    about understanding.- William Paul Thurston
  </p>
);

export default Quote;
